export const DOCUMENT_TYPE_CLIENTS_FRONTPAGE = 'clientsFrontpage';
